const INITIAL_STATE = {
  linkAccessed: '',
  lastOrderId: '',
  whatsappOrderBlock: { blocked: false, reason: '' },
};

export default function system(state = INITIAL_STATE, action) {
  switch (action.type) {
    case '@system/ADD_LINK_ACCESSED':
      return {
        ...state,
        linkAccessed: action.linkAccessed,
      };

    case '@system/ADD_LAST_ORDER_ID':
      return {
        ...state,
        lastOrderId: action.lastOrderId,
      };

    case '@system/SET_WHATSAPP_ORDER_BLOCK':
      if (
        state.whatsappOrderBlock.blocked === action.blocked
        && state.whatsappOrderBlock.reason === action.reason
      ) {
        return state;
      }
      return {
        ...state,
        whatsappOrderBlock: { blocked: action.blocked, reason: action.reason },
      };

    default:
      return state;
  }
}
